import { useOrgs } from '@/contexts/OrgsContext';

/**
 * Returns the maximum number of concurrent Dataverse requests Data Mission Sync makes per Dataverse
 * environment and app registration (issue #474), from the org settings. Zero means no limit is
 * applied (or the settings have not loaded yet).
 */
export function useDataverseConcurrencyLimit(): number {
  const { orgSettings } = useOrgs();
  return orgSettings?.dataverseMaxConcurrentRequests ?? 0;
}
